import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, computed, effect, OnInit, signal } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, firstValueFrom } from 'rxjs';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { CompanyEnums } from 'src/app/enum/company-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { InventoryEntryTypeEnums } from 'src/app/enum/inventory-entry-enums';
import { InventoryOutputTypeEnums } from 'src/app/enum/inventory-output-type-enums';
import { ClassMaintenanceOrderEnum } from 'src/app/enum/maintenance-order-enum';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { EquipmentLogbookPrintModel } from 'src/app/models/archive/equipment-loogbook-print.model';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ChargeAccountsPrintsModel } from 'src/app/models/invoicing/charge-accounts-prints.model';
import { InvoicesPrintsModel } from 'src/app/models/invoicing/invoices-prints.model';
import { InvoicingCutoffModel } from 'src/app/models/invoicing/invoicing-cutoff.model';
import { NotePrintModel } from 'src/app/models/invoicing/note-print.model';
import { RequestNotePrintModel } from 'src/app/models/invoicing/request-note-print.model';
import { MaintenanceOrderPrintModel } from 'src/app/models/maintenance/maintenance-order-print.model';
import { TransferStoreWorkshopModel } from 'src/app/models/maintenance/transfer-store-workshop.model';
import { TransferWorkshopStoreModel } from 'src/app/models/maintenance/transfer-workshop-store.model';
import { CostAdjustmentPrintModel } from 'src/app/models/print/inventory/cost-adjustment-print-model';
import { InventoryEntryPrintModel } from 'src/app/models/print/inventory/inventory-entry-print.model';
import { InventoryOutputPrintModel } from 'src/app/models/print/inventory/inventory-output-print.model';
import { InventoryTransferPrintModel } from 'src/app/models/print/inventory/inventory-transfer-print.model';
import { SalesRemissionPrintModel } from 'src/app/models/print/inventory/sales-remission-print.model';
import { PreinvoicingPrintModel } from 'src/app/models/print/invoicing/preinvoicing-print.model';
import { MaintenanceRoutinePrintModel } from 'src/app/models/print/maintenance/maintenance-routine-print.model';
import { TransferStoreWorkshopPrintModel } from 'src/app/models/print/maintenance/transfer-store-workshop-print.model';
import { TransferWorkshopStorePrintModel } from 'src/app/models/print/maintenance/transfer-workshop-store-print.model';
import { OrderPrintModel } from 'src/app/models/print/preliminaries/order-print.model';
import { QuotationPrintModel } from 'src/app/models/print/preliminaries/quotation-print.model';
import { DevolutionPrintModel } from 'src/app/models/print/rental/devolution-print.model';
import { RemissionPrintModel } from 'src/app/models/print/rental/remission-print.model';
import { LiquidationPrintModel } from 'src/app/models/print/subrental/liquidation-print.model';
import { SubrentalEntryPrintModel } from 'src/app/models/print/subrental/subrental-entry-print.model';
import { SubrentalOutputPrintModel } from 'src/app/models/print/subrental/subrental-output-print.model';
import { CashReceiptPrintModel } from 'src/app/models/print/wallet/cash-receipt-print.model';
import { ServicePrintModel } from 'src/app/models/rental/service-print-model';
import { ServiceModel } from 'src/app/models/rental/service.model';
import { SuspensionPrintModel } from 'src/app/models/rental/suspension-print-model';
import { SuspensionModel } from 'src/app/models/rental/suspension.model';
import { TransferConstructionSitePrintModel } from 'src/app/models/rental/transfer-construction-site-print.model';
import { DocumentSupportPrintModel } from 'src/app/models/shopping/document-support-print.model';
import { InternalOrderPrintModel } from 'src/app/models/shopping/internal-order-print.model';
import { PurchaseOrderPrintModel } from 'src/app/models/shopping/purchase-order-print.model';
import { EquipmentLogbookService } from 'src/app/services/archive/equipment-logbook.service';
import { UserService } from 'src/app/services/authentication/user.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { CostAdjustmentService } from 'src/app/services/inventory/cost-adjustment.service';
import { InventoryEntryService } from 'src/app/services/inventory/inventory-entry.service';
import { InventoryOutputService } from 'src/app/services/inventory/inventory-output.service';
import { InventoryTransferService } from 'src/app/services/inventory/inventory-transfer.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { SalesRemissionService } from 'src/app/services/inventory/sales-remission.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { InvoicingCutoffService } from 'src/app/services/invoicing/invoicing-cutoff.service';
import { MovementService } from 'src/app/services/invoicing/movement.service';
import { NoteService } from 'src/app/services/invoicing/note.service';
import { RequestNoteService } from 'src/app/services/invoicing/request-note.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { MaintenanceRoutineService } from 'src/app/services/maintenance/maintenance-routine.service';
import { TransferStoreWorkshopService } from 'src/app/services/maintenance/transfer-store-workshop.service';
import { TransferWorkshopStoreService } from 'src/app/services/maintenance/transfer-workshop-store.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { DevolutionService } from 'src/app/services/rental/devolution.service';
import { RemissionService } from 'src/app/services/rental/remission.service';
import { ServiceService } from 'src/app/services/rental/service.service';
import { SuspensionService } from 'src/app/services/rental/suspension.service';
import { TransferConstructionSiteService } from 'src/app/services/rental/transfer-construction-site.service';
import { DocumentSupportService } from 'src/app/services/shopping/document-support.service';
import { InternalOrderService } from 'src/app/services/shopping/internal-order.service';
import { PurchaseOrderService } from 'src/app/services/shopping/purchase-order.service';
import { SubrentalEntryService } from 'src/app/services/subrental/subrental-entry.service';
import { SubrentalOutputService } from 'src/app/services/subrental/subrental-output.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CashReceiptService } from 'src/app/services/wallet/cash-receipt.service';
import { CustomValidators } from 'src/app/validators/custom-validators';
import { SubrentalCutoffService } from './../../../../services/subrental/subrental-cutoff.service';

@Component({
  selector: 'app-preview-format',
  templateUrl: './preview-format.component.html',
  styleUrls: ['./preview-format.component.scss'],
  standalone: false
})
export class PreviewFormatComponent implements OnInit {

  branchId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  cashReceiptModel: Array<CashReceiptPrintModel> = new Array<CashReceiptPrintModel>();
  chargeAccountsPrintModel: ChargeAccountsPrintsModel[] = [];
  codeFormat: number = 0;
  companyId: number = 0;
  consecutive: number = 0;
  costAdjustmentPrintModel: CostAdjustmentPrintModel = new CostAdjustmentPrintModel();
  devolutionPrintModel: DevolutionPrintModel = new DevolutionPrintModel();
  disabledForm: boolean = false;
  documentSupportPrintModel: DocumentSupportPrintModel = new DocumentSupportPrintModel();
  enterpriseId: number = 0;
  equipmentLogbookPrintModel: EquipmentLogbookPrintModel = new EquipmentLogbookPrintModel();
  exportFormat: boolean = false;
  finishLoadingPrint: boolean = false;
  focusText: boolean = false;
  formFormat: FormGroup = new FormGroup({});
  formFormatDetail: FormGroup = new FormGroup({});
  formatId = signal<number>(0);
  formatModel = signal<FormatModel>(new FormatModel());
  formatCashReceipt = FormatsEnums.cashReceipt;
  formatChargeAccount = FormatsEnums.chargeAccount;
  formatCostAdjustment = FormatsEnums.costAdjustment;
  formatDetail: FormatDetailModel = new FormatDetailModel();
  formatDetailInput: FormatDetailModel = new FormatDetailModel();
  formatDevolution = FormatsEnums.devolution;
  formatDocumentSupport = FormatsEnums.documentSupport;
  formatInventoryEntry = FormatsEnums.inventoryEntry;
  formatInventoryOutput = FormatsEnums.inventoryOutput;
  formatSalesRemission = FormatsEnums.salesRemission;
  formatInventoryTransfer = FormatsEnums.inventoryTransfer;
  formatInvoice = FormatsEnums.invoice;
  formatInvoicingCutoff = FormatsEnums.invoice;
  formatMaintenanceOrderSite = FormatsEnums.maintenanceOrderSite;
  formatMaintenanceOrderWorkshop = FormatsEnums.maintenanceOrderWorkshop;
  formatMaintenanceOrderScheduled = FormatsEnums.maintenanceOrderScheduled;
  formatNote = FormatsEnums.notes;
  formatOrder = FormatsEnums.order;
  formatInternalOrder = FormatsEnums.internalOrder;
  formatPredevolution = FormatsEnums.predevolution;
  formatPreInvoicing = FormatsEnums.preinvoicing;
  formatLiquidation = FormatsEnums.liquidation;
  formatPurchaseOrder = FormatsEnums.purchaseOrder;
  formatRemission = FormatsEnums.remission;
  formatRequestNote = FormatsEnums.requestNote;
  formatService = FormatsEnums.service;
  formatSimpleEquipmentLogbook = FormatsEnums.simpleEquipmentLogbook;
  formatSubrentalEntry = FormatsEnums.subrentalEntry;
  formatSubrentalOutput = FormatsEnums.subrentalOutput;
  formatSuspension = FormatsEnums.suspension;
  formatTransferConstructionSite = FormatsEnums.transferConstructionSite;
  formatTransferStoreWorkshop = FormatsEnums.transferStoreWorkshop;
  formatTransferWorkshopStore = FormatsEnums.transferWorkshopStore;
  formatValuedEquipmentLogbook = FormatsEnums.valuedEquipmentLogbook;
  formatMaintenanceRoutine = FormatsEnums.maintenanceRoutine;
  formatQuotation = FormatsEnums.quotation;
  generatingPdf: boolean = false;
  hiddenView: boolean = true;
  inventoryId: number = 0;
  internalOrderModel: InternalOrderPrintModel = new InternalOrderPrintModel();
  inventoryEntryModel: InventoryEntryPrintModel = new InventoryEntryPrintModel();
  inventoryOutputPrintModel: InventoryOutputPrintModel = new InventoryOutputPrintModel();
  inventoryTransferPrintModel: InventoryTransferPrintModel = new InventoryTransferPrintModel();
  invoicesPrintModel: InvoicesPrintsModel[] = [];
  invoicingCutoffModel: InvoicingCutoffModel = new InvoicingCutoffModel();
  preinvoicingPrintModel: PreinvoicingPrintModel[] = [];
  liquidationPrintModel: LiquidationPrintModel[] = [];
  isLevelArticle: boolean = false;
  isGeneralFormat: boolean = true;
  isPdfFormat = computed(() => this.formatModel().code === FormatsEnums.invoice || this.formatModel().code === FormatsEnums.notes);
  isPrincipalCompany: boolean = false;
  listAlignment: CustomListDropdown[] = [{ label: 'Left', value: 'left' }, { label: 'Right', value: 'right' },
  { label: 'Center', value: 'center' }, { label: 'Justify', value: 'justify' }];
  listBold: CustomListDropdown[] = [{ label: 'Normal', value: 'normal' }, { label: 'Bold', value: 'bold' }, { label: 'Lighter', value: 'lighter' }];
  listBorder: CustomListDropdown[] = [{ label: 'NoBorder', value: 'noborder' }, { label: 'Border', value: 'border' }, { label: 'Underline', value: 'underline' }];
  listBranches: any[] = [];
  listCompany: any[] = [];
  listEnterprises: any[] = [];
  listFormat: any[] = [];
  listFormatType: CustomListDropdown[] = [{ label: 'General', value: 1 }, { label: 'M2', value: 2 }];
  maintenanceOrderScheduledPrintModel: MaintenanceOrderPrintModel = new MaintenanceOrderPrintModel();
  maintenanceOrderSitePrintModel: MaintenanceOrderPrintModel = new MaintenanceOrderPrintModel();
  maintenanceOrderWorkshopPrintModel: MaintenanceOrderPrintModel = new MaintenanceOrderPrintModel();
  maintenanceRoutinePrintModel: MaintenanceRoutinePrintModel = new MaintenanceRoutinePrintModel();
  notePrintModel: NotePrintModel = new NotePrintModel();
  noteTypeId: number = 0;
  purchaseOrderPrintModel: PurchaseOrderPrintModel = new PurchaseOrderPrintModel();
  reloadPrint: boolean = false;
  remissionPrintModel: RemissionPrintModel = new RemissionPrintModel();
  requestNotePrintModel: RequestNotePrintModel = new RequestNotePrintModel();
  salesRemissionPrintModel: SalesRemissionPrintModel = new SalesRemissionPrintModel();
  serviceModel: ServiceModel = new ServiceModel();
  servicePrintModel: ServicePrintModel = new ServicePrintModel();
  suspensionPrintModel: SuspensionPrintModel = new SuspensionPrintModel();
  swIncludeStore: boolean = false;
  orderPrintModel: OrderPrintModel = new OrderPrintModel();
  transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel = new TransferStoreWorkshopPrintModel();
  transferWorkshopStorePrintModel: TransferWorkshopStorePrintModel = new TransferWorkshopStorePrintModel();
  subrentalEntryPrintModel: SubrentalEntryPrintModel = new SubrentalEntryPrintModel();
  subrentalOutputPrintModel: SubrentalOutputPrintModel = new SubrentalOutputPrintModel();
  suspensionModel: SuspensionModel = new SuspensionModel();
  swMaintenanceOrder: boolean = false;
  transferConstructionSitePrintModel: TransferConstructionSitePrintModel = new TransferConstructionSitePrintModel();
  transferStoreWorkshopModel: TransferStoreWorkshopModel = new TransferStoreWorkshopModel();
  transferWorkshopStoreModel: TransferWorkshopStoreModel = new TransferWorkshopStoreModel();
  quotationPrintContract: QuotationPrintModel = new QuotationPrintModel();
  readonly IS_BAND_DODY = this.formatDetail.band === 'body';
  readonly IS_MO_WORKSHOP = this.formatModel().code !== FormatsEnums.maintenanceOrderWorkshop;
  readonly IS_MO_SITE = this.formatModel().code !== FormatsEnums.maintenanceOrderSite;
  value: number = 50;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private cashReceiptService: CashReceiptService,
    private chargeAccountService: ChargeAccountService,
    private companyService: CompanyService,
    private confirmDialogService: ConfirmDialogService,
    private costAdjustmentService: CostAdjustmentService,
    private devolutionService: DevolutionService,
    private documentSupportService: DocumentSupportService,
    private equipmentLogbookService: EquipmentLogbookService,
    private enterpriseService: EnterpriseService,
    private subrentalCutoffService: SubrentalCutoffService,
    private formatServices: FormatService,
    private formBuilder: UntypedFormBuilder,
    private generalParameterService: GeneralParameterService,
    private internalOrderService: InternalOrderService,
    private inventoryService: InventoryService,
    private inventoryEntryService: InventoryEntryService,
    private inventoryOutputService: InventoryOutputService,
    private inventoryTransferService: InventoryTransferService,
    private invoiceService: InvoiceService,
    private invoicingCutoffService: InvoicingCutoffService,
    private location: Location,
    private maintenanceOrderService: MaintenanceOrderService,
    private maintenanceRoutineService: MaintenanceRoutineService,
    private movementService: MovementService,
    private noteService: NoteService,
    private orderService: OrderService,
    private purchaseOrderService: PurchaseOrderService,
    private quotationService: QuotationService,
    private remissionService: RemissionService,
    private requestNoteService: RequestNoteService,
    private router: Router,
    private salesRemissionService: SalesRemissionService,
    private serviceService: ServiceService,
    private subrentalEntryService: SubrentalEntryService,
    private subrentalOutputService: SubrentalOutputService,
    private suspensionService: SuspensionService,
    private toastHandlerService: ToastHandlerService,
    private transferConstructionSiteService: TransferConstructionSiteService,
    private transferStoreWorkshopService: TransferStoreWorkshopService,
    private transferWorkshopStoreService: TransferWorkshopStoreService,
    private userService: UserService) {
    this.validateForm(this.formatModel());
    this.validateFormDetail(new FormatDetailModel());
    setTimeout(() => this.formFormatDetail.controls["name"].disable(), 100);

    this.activatedRoute.params.subscribe(params => {
      this.formatId.set(params?.id);
    });

    effect(() => {
      if (this.formatId() && this.formatId() > 0) {
        this.location.replaceState(`/format/${this.formatId()}`);
      } else {
        this.location.replaceState(`/format`);
      }
    });
  }

  async ngOnInit() {
    await Promise.all([
      this.getAllLists(),
      this.userAuthenticatedIsPrincipalCompany()
    ]);
    await this.handleInitialState();
  }

  ngAfterViewInit() {
    const text = document.getElementById('text');
    text!.addEventListener('focus', () => {
      this.focusText = true;
    });
    text!.addEventListener('blur', () => {
      this.focusText = false;
    });
  }

  async changeCompany(change: boolean) {
    this.companyId = this.formFormat.get("companyId")?.value;
    if (change) {
      this.formatId.set(0);
      this.formatModel.set(new FormatModel());
      this.formatModel().companyId = this.companyId;
      this.formFormat.controls['code'].patchValue(0);
      this.formFormat.controls['consecutive'].patchValue(0);
    }
    await this.getAllBranchesByCompanyId()
    await this.getGeneralParametersByCompany();
  }

  async changeConsecutive() {
    this.consecutive = this.formFormat.get("consecutive")?.value;
    switch (this.formatModel().code) {
      case FormatsEnums.invoice: {
        if (this.consecutive === 0) {
          this.invoicesPrintModel = [];
        } else {
          this.getInvoiceByKeysAsync();
        }
        break;
      }
      case FormatsEnums.remission: {
        this.getRemissionByKeysByPrint();
        break;
      }
      case FormatsEnums.suspension: {
        await this.getSuspensionByKeysByPrintAsync();
        break;
      }
      case FormatsEnums.devolution: {
        await this.getDevolutionByKeysByPrintAsync(false);
        break;
      }
      case FormatsEnums.predevolution: {
        await this.getDevolutionByKeysByPrintAsync(true);
        break;
      }
      case FormatsEnums.service: {
        await this.getServiceByKeysByPrintAsync();
        break;
      }
      case FormatsEnums.inventoryEntry: {
        if (this.consecutive === 0) {
          this.inventoryEntryModel = new InventoryEntryPrintModel();
        } else {
          this.getInventoryEntryByKeysAsync();
        }
        break;
      }
      case FormatsEnums.inventoryOutput: {
        await this.getInventoryOutputByKeysAsync(InventoryOutputTypeEnums.output);
        break;
      }
      case FormatsEnums.salesRemission: {
        await this.getSalesRemissionByKeysAsync();
        break;
      }
      case FormatsEnums.costAdjustment: {
        await this.getCostAdjustmentByKeysByPrint();
        break;
      }
      case FormatsEnums.inventoryTransfer: {
        if (this.consecutive === 0) {
          this.inventoryTransferPrintModel = new InventoryTransferPrintModel();
        } else {
          this.getInventoryTransferForPrint();
        }
        break;
      }
      case FormatsEnums.subrentalEntry: {
        this.getSubrentalEntryByKeysByPrint();
        break;
      }
      case FormatsEnums.subrentalOutput: {
        this.getSubrentalOutputByKeysByPrint();
        break;
      }
      case FormatsEnums.preinvoicing: {
        if (this.consecutive === 0) {
          this.preinvoicingPrintModel = [];
        } else {
          this.getInvoicingCutoffByKeysAsync();
        }
        break;
      }
      case FormatsEnums.liquidation: {
        this.getLiquidationCutoffByKeysAsync();
        break;
      }
      case FormatsEnums.notes: {
        if (this.consecutive === 0) {
          this.notePrintModel = new NotePrintModel()
        } else {
          this.getNoteByKeysAsync();
        }
        break;
      }
      case FormatsEnums.requestNote: {
        this.getRequestNoteByKeysByPrintAsync();
        break;
      }
      case FormatsEnums.chargeAccount: {
        if (this.consecutive === 0) {
          this.chargeAccountsPrintModel = [];
        } else {
          this.getChargeAccountByKeysAsync();
        }
        break;
      }
      case FormatsEnums.documentSupport: {
        if (this.consecutive === 0) {
          this.documentSupportPrintModel = new DocumentSupportPrintModel();
        } else {
          this.getDocumentSupportByKeysAsync();
        }
        break;
      }
      case FormatsEnums.cashReceipt: {
        this.getCashReceiptsByKeysByPrintAsync();
        break;
      }
      case FormatsEnums.order: {
        await this.getOrderByKeysByPrintAsync();
        break;
      }
      case FormatsEnums.transferStoreWorkshop: {
        await this.getTransferStoreWorkshopByKeysByPrint();
        break;
      }
      case FormatsEnums.transferWorkshopStore: {
        await this.getTransferWorkshopStoreByKeysByPrint();
        break;
      }
      case FormatsEnums.quotation: {
        this.getQuotationByKeysByPrint();
        break;
      }
      case FormatsEnums.transferConstructionSite: {
        if (this.consecutive === 0) {
          this.transferConstructionSitePrintModel = new TransferConstructionSitePrintModel();
        } else {
          this.getTransferConstructionSiteByKeysAsync();
        }
        break;
      }
      case FormatsEnums.purchaseOrder: {
        if (this.consecutive === 0) {
          this.purchaseOrderPrintModel = new PurchaseOrderPrintModel;
        } else {
          this.getPurchaseOrderByKeys();
        }
        break;
      }
      case FormatsEnums.internalOrder: {
        if (this.consecutive === 0) {
          this.internalOrderModel = new InternalOrderPrintModel();
        } else {
          this.getInternalOrderByKeysAsync();
        }
        break;
      }
      case FormatsEnums.maintenanceOrderSite: {
        if (this.consecutive === 0) {
          this.maintenanceOrderSitePrintModel = new MaintenanceOrderPrintModel();
        } else {
          await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.enSitio);
        }
        break;
      }
      case FormatsEnums.maintenanceOrderWorkshop: {
        if (this.consecutive === 0) {
          this.maintenanceOrderWorkshopPrintModel = new MaintenanceOrderPrintModel();
        } else {
          await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.enTaller);
        }
        break;
      }
      case FormatsEnums.maintenanceOrderScheduled: {
        if (this.consecutive === 0) {
          this.maintenanceOrderScheduledPrintModel = new MaintenanceOrderPrintModel();
        } else {
          await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.programada);
        }
        break;
      }
      case FormatsEnums.maintenanceRoutine: {
        if (this.consecutive === 0) {
          this.maintenanceRoutinePrintModel = new MaintenanceRoutinePrintModel();
        } else {
          await this.getMaintenanceRoutineByKeysByPrintAsync();
        }
        break;
      }
      case FormatsEnums.simpleEquipmentLogbook:
      case FormatsEnums.valuedEquipmentLogbook: {
        await this.getEquipmentLogbookByKeysByPrintAsync();
        break;
      }
    }
  }

  changeAlignment() {
    this.formatDetail.alignment = this.formFormatDetail.get("alignment")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeBold() {
    this.formatDetail.bold = this.formFormatDetail.get("bold")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeBorder() {
    this.formatDetail.border = this.formFormatDetail.get("border")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeFontSize() {
    this.formatDetail.fontSize = this.formFormatDetail.get("fontSize")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeFormatDetail(formatDetailId: number,
    formatId: number,
    name: string,
    description: string | null,
    band: string,
    type: string,
    visible: boolean,
    left: number,
    top: number,
    width: number,
    height: number,
    fontSize: number,
    bold: string,
    alignment: string,
    border: string,
    text: string | null,
    printFormat: string | null): FormatDetailModel {
    const response = new FormatDetailModel();
    response.formatDetailId = formatDetailId;
    response.formatId = formatId;
    response.name = name;
    response.description = description;
    response.band = band;
    response.type = type;
    response.visible = visible;
    response.left = left;
    response.top = top;
    response.width = width;
    response.height = height;
    response.fontSize = fontSize;
    response.bold = bold;
    response.alignment = alignment;
    response.border = border;
    response.text = text;
    response.printFormat = printFormat;
    return response;
  }

  changeLeft() {
    this.formatDetail.left = this.formFormatDetail.get("left")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeHeight() {
    this.formatDetail.height = this.formFormatDetail.get("height")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeText() {
    this.formatDetail.text = this.formFormatDetail.get("text")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changePrintFormat() {
    this.formatDetail.printFormat = this.formFormatDetail.get("printFormat")?.value;
    if (this.formatDetail.printFormat && this.formatDetail.printFormat.trim() === "") {
      this.formatDetail.printFormat = null;
    }

    this.formatDetailInput = this.changeFormatDetail(
      this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat
    );
  }

  changeTop() {
    this.formatDetail.top = this.formFormatDetail.get("top")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeWidth() {
    this.formatDetail.width = this.formFormatDetail.get("width")?.value;
    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat);
  }

  changeVisible() {
    this.formatDetail.visible = this.formFormatDetail.get("visible")?.value;

    this.formatDetailInput = this.changeFormatDetail(this.formatDetail.formatDetailId,
      this.formatDetail.formatId,
      this.formatDetail.name,
      this.formatDetail.description,
      this.formatDetail.band,
      this.formatDetail.type,
      this.formatDetail.visible,
      this.formatDetail.left,
      this.formatDetail.top,
      this.formatDetail.width,
      this.formatDetail.height,
      this.formatDetail.fontSize,
      this.formatDetail.bold,
      this.formatDetail.alignment,
      this.formatDetail.border,
      this.formatDetail.text,
      this.formatDetail.printFormat
    );
  }

  changeFormatType(formatType: any) {
    this.isGeneralFormat = formatType == 1;
  }

  downloadPreviewPdf() {
    //Evita generar el pdf varias veces si se hace clic mientras se está generando
    if (this.generatingPdf) return;

    const { code, formatId } = this.formatModel();
    const invoice = this.invoicesPrintModel[0];
    const note = this.notePrintModel;

    const documents = {
      invoice: { id: invoice?.invoiceId, name: 'factura', fileName: `Factura ${invoice?.consecutive}.pdf` },
      note: { id: note?.noteId, name: 'nota', fileName: `Nota ${note?.consecutive}.pdf` }
    };

    const documentType = code === FormatsEnums.invoice ? 'invoice' : 'note';
    const { id: documentId, name: documentName, fileName } = documents[documentType];

    if (!documentId) {
      this.toastHandlerService.showToast(
        'warning',
        `Consulte una ${documentName} para descargar el PDF.`
      );
      return;
    }

    this.generatingPdf = true;
    this.formatServices.downloadPreviewPdfAsync(formatId, documentId).pipe(
      finalize(() => this.generatingPdf = false)
    ).subscribe({
      next: event => {
        if (event.type !== HttpEventType.Response || !event.body) return;
        const url = URL.createObjectURL(event.body);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
      },
      error: error => console.error(`Error al descargar el PDF de la ${documentName}.`, error)
    });
  }

  async exportFormatChanges() {
    if (this.formatModel().formatId !== 0 && this.formatModel().formatId !== null) {
      if (await this.confirmDialogService.confirm(`¿Realmente desea modificar el formato de ${this.formatModel().name}?`)) {
        this.exportFormat = !this.exportFormat;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar un formato.'
      );
      return;
    }
  }

  async getAllLists(...listsToLoad: Array<'companies' | 'formats'>) {
    try {
      const lists = {
        companies: async () => {
          this.listCompany = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
        },
        formats: async () => {
          this.listFormat = await firstValueFrom(this.formatServices.getAllFormatsForSelectAsync());
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.companies(),
          lists.formats()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }


  async getAllBranchesByCompanyId() {
    this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    await this.getFirstBranchByCompanyId(this.companyId);
  }

  async getCashReceiptsByKeysByPrintAsync() {
    const consecutive = this.formFormat.get("consecutive")?.value as number;
    if (!this.validateBranchAndEnterprise()) return;
    try {
      this.cashReceiptModel = await firstValueFrom(this.cashReceiptService.getCashReceiptsByKeysByPrintAsync(
        this.branchId, this.enterpriseId, false, consecutive, consecutive
      ));
      this.formFormat.controls["consecutive"].patchValue(this.cashReceiptModel[0].consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la impresión del recibo de caja por consecutivo:", error);
      this.cashReceiptModel = Array<CashReceiptPrintModel>();
    }
  }

  async getChargeAccountByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.chargeAccountService.getChargeAccountByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!, this.consecutive));
      this.getPrintChargeAccountForFormat(response.invoiceId);
    } catch (error) {
      console.error("Error al obtener la cuenta de cobro por claves:", error);
    }
  }

  async getBranch(branchId: number) {
    if (branchId !== null && branchId !== 0) {
      this.branchId = branchId;
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
      const enterpriseModel = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      this.enterpriseId = enterpriseModel.enterpriseId;
      this.formFormat.patchValue({ branchId: this.branchId, enterpriseId: this.enterpriseId });
    } else {
      this.branchId = 0;
      this.enterpriseId = 0;
      this.formFormat.patchValue({ branchId: 0, enterpriseId: 0 });
    }
    this.formFormat.patchValue({ consecutive: 0 });
    this.hiddenView = true;
  }

  getEnterprise(enterpriseId: number) {
    this.enterpriseId = enterpriseId;
    this.formFormat.patchValue({ consecutive: 0 });
    this.hiddenView = true;
  }

  getCompany(companyId: number, reload: boolean) {
    this.finishLoadingPrint = false;
    this.hiddenView = true;
    if (companyId !== null && companyId !== 0) {
      this.companyId = companyId;
    } else {
      this.formFormat.controls["companyId"].patchValue(0);
      this.companyId = 0;
    }
    if (reload) {
      this.changeCompany(reload);
    }
  }

  async getCostAdjustmentByKeysByPrint() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const consecutive = this.formFormat.get("consecutive")?.value as number;
      const response = await firstValueFrom(this.costAdjustmentService.getCostAdjustmentByKeysByPrint(0, this.branchId, consecutive));
      this.costAdjustmentPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la impresión del ajuste de costos por consecutivo.", error);
      this.costAdjustmentPrintModel = new CostAdjustmentPrintModel();
    }
  }

  async getDevolutionByKeysByPrintAsync(isPredevolution: boolean) {
    const consecutive = this.formFormat.get("consecutive")?.value as number;
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.devolutionService.getDevolutionByKeysByPrintAsync(this.branchId, consecutive, 0, isPredevolution, true, false));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.devolutionPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la impresión de la devolución por consecutivo:", error);
      this.devolutionPrintModel = new DevolutionPrintModel();
    }
  }

  async getDocumentSupportByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.documentSupportService.getDocumentSupportByKeysAsync(
        this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!, this.consecutive!
      ));
      this.getPrintDocumentSupportForFormat(response.documentSupportId);
    } catch (error) {
      console.error("Error al obtener el documento soporte por claves:", error);
    }
  }

  async getEquipmentLogbookByKeysByPrintAsync() {
    try {
      const response = await firstValueFrom(this.equipmentLogbookService.getEquipmentLogbookByKeysByPrintAsync(this.companyId, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.equipmentLogbookPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error getting a consecutive print:", error);
      this.equipmentLogbookPrintModel = new EquipmentLogbookPrintModel();
    }
  }

  async getLiquidationCutoffByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      this.liquidationPrintModel = await firstValueFrom(this.subrentalCutoffService.getLiquidationCutoffByKeysAsync(this.branchId, this.consecutive, null, null));
      this.formFormat.controls["consecutive"].patchValue(this.liquidationPrintModel[0].consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.finishLoadingPrint = false;
      await this.waitForComponenteImpresionToLoad();
    } catch (error) {
      console.error("Error al obtener el corte de subalquiler por claves:", error);
    }
  }

  async getRequestNoteByKeysByPrintAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      this.requestNotePrintModel = await firstValueFrom(
        this.requestNoteService.getRequestNoteByKeysByPrintAsync(this.branchId, this.consecutive, false, null)
      );
      this.formFormat.controls["consecutive"].patchValue(this.requestNotePrintModel.requestConsecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.finishLoadingPrint = false;
      await this.waitForComponenteImpresionToLoad();
    } catch (error) {
      console.error("Error al obtener la solicitud de nota por claves:", error);
    }
  }

  async getServiceByKeysByPrintAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.serviceService.getServiceByKeysByPrintAsync(this.branchId, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.servicePrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error getting a consecutive print:", error);
      this.servicePrintModel = new ServicePrintModel();
    }
  }

  async getSuspensionByKeysByPrintAsync() {
    const consecutive = this.formFormat.get("consecutive")?.value as number;
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.suspensionService.getSuspensionByKeysByPrintAsync(this.branchId, consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.suspensionPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error getting a consecutive print:", error);
      this.suspensionPrintModel = new SuspensionPrintModel();
    }
  }

  async getOrderByKeysByPrintAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const consecutive = this.formFormat.get("consecutive")?.value as number;
      const response = await firstValueFrom(this.orderService.getOrderByKeysByPrintAsync(this.branchId, consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.orderPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      this.orderPrintModel = new OrderPrintModel();
      console.error("Error al obtener impresión de pedidos.", error);
    }
  }

  async getFirstBranchByCompanyId(companyId: number) {
    try {
      const data = await firstValueFrom(this.formatServices.getFirstBranchEnterpriseByCompanyId(companyId));
      this.branchId = data.branchId;
      await this.getBranch(data.branchId);
    } catch (error) {
      console.error('Error getting first branch and company by company ID:', error);
    }
  }

  getFirstBussinessDocumentsType = async (bussinessDocumentsClass: number) => {
    return new Promise((resolved) => {
      (async () => {
        if (!this.validateBranchAndEnterprise()) return;
        try {
          const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(bussinessDocumentsClass, this.enterpriseId));
          this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
          resolved(response.bussinessDocumentsTypeId)
        } catch (error) {
          console.error('Error al obtener el primer tipo de documento de negocio:', error);
        }
      })();
    });
  }

  getFirstInventoryByCompanyAuthenticatedAsync() {
    return new Promise((resolved) => {
      (async () => {
        if (this.companyId != 0 && this.companyId != null) {
          const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyId(this.companyId));
          this.inventoryId = response.inventoryId;
          resolved(true)
        }
      })();
    });
  }

  async getFormatByCode(code: number | null) {
    this.hiddenView = true;
    setTimeout(() => this.formFormat.controls["consecutive"].disable(), 100);
    if (this.companyId === null || this.companyId === 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una compañía.');
      return;
    } else if (code === null) {
      code = 0;
    }

    if (code === 0) {
      this.formatId.set(0);
      this.formatModel.set(new FormatModel());
      this.formatModel().companyId = this.companyId;
    } else {
      //limpia consecutivo cuando cambia el formato
      this.formFormat.controls["consecutive"].patchValue(0);
      this.consecutive = 0;
      try {
        this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId, code)));
        this.formatId.set(this.formatModel().formatId);
        this.codeFormat = this.formatModel().code;
        this.formFormat.controls["code"].patchValue(this.codeFormat);
        this.importFormat();
        this.validateFormDetail(new FormatDetailModel);
      } catch (error) {
        const modelFormat = new FormatModel();
        modelFormat.formatId = -1;
        modelFormat.companyId = this.companyId;
        this.validateFormDetail(new FormatDetailModel);
        console.error('problemas al buscar el formato de la compañía', error)
      }
    }
  }

  async getFormatById() {
    try {
      this.formatModel.set(await firstValueFrom(this.formatServices.getFormatById(this.formatId())));
      this.codeFormat = this.formatModel().code;
      this.companyId = this.formatModel().companyId;
      this.formFormat.controls["companyId"].patchValue(this.companyId);
      this.formFormat.controls["code"].patchValue(this.codeFormat);
    } catch (error) {
      console.error("Error al obtener el formato por ID:", error);
    }
  }

  getFormatDetail(formatDetail: FormatDetailModel) {
    this.formatDetail = formatDetail;
    this.validateFormDetail(formatDetail);
    if (this.IS_BAND_DODY && this.IS_MO_WORKSHOP && this.IS_MO_SITE) {
      setTimeout(() => {
        this.formatPredevolution == this.formatModel().code ? this.formFormatDetail.controls["border"].enable() :
          this.formFormatDetail.controls["border"].disable();
        this.formFormatDetail.controls["left"].disable();
        this.formFormatDetail.controls["top"].disable();
        this.formFormatDetail.controls["height"].disable();
      }, 100);
      if (this.formatDetail.type === 'label') {
        setTimeout(() => {
          this.formFormatDetail.controls["visible"].enable();
          this.formFormatDetail.controls["bold"].disable();
          this.formFormatDetail.controls["width"].enable();
        }, 100);
      } else {
        setTimeout(() => {
          this.formFormatDetail.controls["width"].disable();
          this.formFormatDetail.controls["bold"].enable();
          if (this.formatDetail.name === 'articulo-reparacion') {
            this.formFormatDetail.controls["visible"].enable();
            this.formFormatDetail.controls["border"].enable();
          } else {
            this.formFormatDetail.controls["visible"].disable();
          }
        }, 100);
      }
    } else {
      setTimeout(() => {
        if (this.formatDetail.name.includes('foot-group-')) {
          this.formFormatDetail.controls["visible"].disable();
          this.formFormatDetail.controls["left"].disable();
          this.formFormatDetail.controls["top"].disable();
        } else if (this.formatDetail.name.includes('foot-')) {
          this.formFormatDetail.controls["visible"].enable();
          this.formFormatDetail.controls["left"].disable();
          this.formFormatDetail.controls["top"].disable();
        } else {
          this.formFormatDetail.controls["visible"].enable();
          this.formFormatDetail.controls["left"].enable();
          this.formFormatDetail.controls["top"].enable();
        }
        this.formFormatDetail.controls["border"].enable();
        this.formFormatDetail.controls["bold"].enable();
        this.formFormatDetail.controls["width"].enable();
        this.formFormatDetail.controls["height"].enable();
      }, 100);
    }

    if (this.formatDetail.type === 'label') {
      setTimeout(() => this.formFormatDetail.controls["text"].enable(), 100);
    } else {
      setTimeout(() => this.formFormatDetail.controls["text"].disable(), 100);
    }
  }

  async getFormatEmpty() {
    try {
      const code = this.formatModel().code;
      switch (code) {
        case FormatsEnums.inventoryEntry:
          this.inventoryEntryModel = await firstValueFrom(this.inventoryEntryService.getEmptyPrintInventoryEntry());
          break;
        case FormatsEnums.inventoryTransfer:
          this.inventoryTransferPrintModel = await firstValueFrom(this.inventoryTransferService.getEmptyInventoryTransferPrint());
          break;
        case FormatsEnums.internalOrder:
          this.internalOrderModel = await firstValueFrom(this.internalOrderService.getEmptyPrintInternalOrder());
          break;
        case FormatsEnums.service:
          this.servicePrintModel = await firstValueFrom(this.serviceService.getEmptyServicePrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        case FormatsEnums.remission:
          this.remissionPrintModel = await firstValueFrom(this.remissionService.getEmptyRemissionPrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        case FormatsEnums.suspension: {
          this.suspensionPrintModel = await firstValueFrom(this.suspensionService.getEmptySuspensionPrint())
          this.reloadPrint = !this.reloadPrint;
          break;
        }
        case FormatsEnums.devolution: {
          this.devolutionPrintModel = await firstValueFrom(this.devolutionService.getEmptyDevolutionPrint());
          this.reloadPrint = !this.reloadPrint;
          this.finishLoadingPrint = true;
          break;
        }
        case FormatsEnums.predevolution: {
          this.devolutionPrintModel = await firstValueFrom(this.devolutionService.getEmptyDevolutionPrint());
          this.reloadPrint = !this.reloadPrint;
          this.finishLoadingPrint = true;
          break;
        }
        case FormatsEnums.order: {
          this.orderPrintModel = await firstValueFrom(this.orderService.getEmptyOrderPrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        }
        case FormatsEnums.inventoryOutput: {
          this.inventoryOutputPrintModel = await firstValueFrom(this.inventoryOutputService.getEmptyInventoryOutputPrint());
          break;
        }
        case FormatsEnums.subrentalEntry: {
          this.subrentalEntryPrintModel = await firstValueFrom(this.subrentalEntryService.getEmptySubrentalEntryPrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        }
        case FormatsEnums.subrentalOutput: {
          this.subrentalOutputPrintModel = await firstValueFrom(this.subrentalOutputService.getEmptySubrentalOutputPrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        }
        case FormatsEnums.quotation:
          this.quotationPrintContract = await firstValueFrom(this.quotationService.getEmptyQuotationPrint());
          this.reloadPrint = !this.reloadPrint;
          break;
        case FormatsEnums.cashReceipt: {
          this.cashReceiptModel = await firstValueFrom(this.cashReceiptService.getEmptyCashReceiptPrint());
          break;
        }
        case FormatsEnums.salesRemission: {
          this.salesRemissionPrintModel = await firstValueFrom(this.salesRemissionService.getEmptySalesRemissionPrint());
          break;
        }
        case FormatsEnums.transferStoreWorkshop: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.transferStoreWorkshop)));
          this.transferStoreWorkshopPrintModel = await firstValueFrom(this.transferStoreWorkshopService.getEmptyTransferStoreWorkshopPrint());
          break;
        }
        case FormatsEnums.transferWorkshopStore: {
          this.transferWorkshopStorePrintModel = await firstValueFrom(this.transferWorkshopStoreService.getEmptyTransferWorkshopStorePrint());
          break;
        }
        case FormatsEnums.liquidation: {
          this.liquidationPrintModel = await firstValueFrom(this.subrentalCutoffService.getEmptyLiquidationPrint());
          break;
        }
        case FormatsEnums.costAdjustment:
          this.costAdjustmentPrintModel = await firstValueFrom(this.costAdjustmentService.getEmptyCostAdjustmentPrint());
          break;
        case FormatsEnums.simpleEquipmentLogbook:
        case FormatsEnums.valuedEquipmentLogbook: {
          this.equipmentLogbookPrintModel = await firstValueFrom(this.equipmentLogbookService.getEmptyEquipmentLogbook());
          break;
        }
        case FormatsEnums.maintenanceRoutine: {
          this.maintenanceRoutinePrintModel = await firstValueFrom(this.maintenanceRoutineService.getEmptyMaintenanceRoutinePrint());
          break;
        }
        case FormatsEnums.requestNote: {
          this.requestNotePrintModel = await firstValueFrom(this.requestNoteService.getEmptyRequestNotePrint());
          break;
        }
      }
      this.finishLoadingPrint = true;
    } catch (error) {
      console.error('Error al buscar el formato de impresión en vacía.', error);
    }
  }

  async getGeneralParametersByCompany() {
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId!));
        this.swIncludeStore = response.some(x => x.generalParameterId === GeneralParameterEnums.ImprimirBodegaDocumento);
      } catch (error) {
        console.error('Error to get general parameters by company:', error);
      }
    }
  }

  async getInventoryEntryByKeysAsync() {
    await this.getFirstInventoryByCompanyAuthenticatedAsync();
    const inventoryEntryTypeId = InventoryEntryTypeEnums.entry;

    if (!this.validateBranchAndEnterprise()) return;
    const response = await firstValueFrom(this.inventoryEntryService.getInventoryEntryByKeysAsync(this.inventoryId!, this.branchId, inventoryEntryTypeId, this.consecutive));
    response.inventoryEntryId != 0 ? this.getPrintInventoryEntryForFormat(response.inventoryEntryId) : this.getFormatEmpty();
  }

  async getInventoryOutputByKeysAsync(inventoryOutputTypeId: number) {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(
        this.inventoryOutputService.getInventoryOutputByKeysForPrintAsync(0, this.inventoryId!, this.branchId, inventoryOutputTypeId!, this.consecutive)
      );
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.inventoryOutputPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la impresión de la salida de inventario por consecutivo:", error);
      this.inventoryOutputPrintModel = new InventoryOutputPrintModel();
    }
  }

  async getInventoryTransferForPrint() {
    try {
      const response = await firstValueFrom(this.inventoryTransferService.getInventoryTransferForPrint(this.companyId!, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.inventoryTransferPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la impresión del traslado de inventario por consecutivo:", error);
    }
  }

  async getInvoiceByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.invoiceService.getInvoiceByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!, this.consecutive));
      this.getPrintInvoiceForFormat(response.invoiceId);
    } catch (error) {
      console.error("Error al obtener la factura por claves:", error);
    }
  }

  async getInvoicingCutoffByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.invoicingCutoffService.getInvoicingCutoffByKeysForFormats(this.branchId, this.consecutive));
      this.getPrintInvoicingCutoffForFormat(response.invoicingCutoffId);
    } catch (error) {
      console.error("Error al obtener el corte de facturación por claves:", error);
    }
  }

  async getLastChargeAccountByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;

      const response = await firstValueFrom(this.chargeAccountService.getLastChargeAccountByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!));
      this.getPrintChargeAccountForFormat(response.invoiceId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última cuenta de cobro por claves:", error);
    }
  }

  async getLastDocumentSupportByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    const response = await firstValueFrom(this.documentSupportService.getLastDocumentSupportByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!))
    this.getPrintDocumentSupportForFormat(response.documentSupportId);
    this.formFormat.controls["consecutive"].patchValue(response.consecutive);
    setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
  }

  async getLastInvoiceByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.invoiceService.getLastInvoiceByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId!));
      this.getPrintInvoiceForFormat(response.invoiceId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última factura por claves:", error);
    }
  }

  async getLastInvoicingCutoffByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.invoicingCutoffService.getLastInvoicingCutoffByKeysForFormats(this.branchId));
      this.getPrintInvoicingCutoffForFormat(response.invoicingCutoffId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener el último corte de facturación por claves:", error);
    }
  }

  async getLastMaintenanceOrderByKeysAsync(maintenanceOrderClass: number) {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.maintenanceOrderService.getLastMaintenanceOrderByKeysAsync(this.branchId, maintenanceOrderClass));
      this.consecutive = response.consecutive;
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      this.getMaintenanceOrderByKeysByPrintAsync(maintenanceOrderClass);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la ultima orden de mantenimiento:", error);
    }
  }

  async getLastNoteByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.noteService.getLastNoteForFormats(this.branchId, this.enterpriseId));
      this.getPrintNoteForFormat(response.noteId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última nota por claves:", error);
    }
  }

  async getLastPurchaseOrderByKeys() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      const response = await firstValueFrom(this.purchaseOrderService.getLastPurchaseOrderByKeys(this.branchId));
      this.getPrintPurchaseOrder(response.purchaseOrderId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última orden de compra por claves:", error);
    }
  }

  async getLastServiceByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.serviceService.getLastServiceByKeysAsync(this.branchId));
      this.getPrintServiceForFormat(response.serviceId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener el último servicio:", error);
    }
  }

  async getLastSuspensionByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.suspensionService.getLastSuspensionByKeysAsync(this.branchId));
      this.getPrintSuspensionForFormat(response.suspensionId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última suspensión:", error);
    }
  }

  async getLastTransferConstructionSiteByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.transferConstructionSiteService.getLastTransferConstructionSiteByKeysAsync(this.branchId));
      this.getPrintTransferConstructionSiteForFormat(response.transferConstructionSiteId);
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } catch (error) {
      console.error("Error al obtener la última transferencia de obra:", error);
    }
  }

  async getTransferStoreWorkshopByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const consecutive = this.formFormat.get("consecutive")?.value as number;
      const response = await firstValueFrom(this.transferStoreWorkshopService.getTransferStoreWorkshopByKeysByPrint(this.branchId,
        consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.transferStoreWorkshopPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      this.transferStoreWorkshopPrintModel = new TransferStoreWorkshopPrintModel();
      console.error("Error al obtener impresión del traslado.", error);
    }
  }

  async getTransferWorkshopStoreByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const consecutive = this.formFormat.get("consecutive")?.value as number;
      const response = await firstValueFrom(this.transferWorkshopStoreService.getTransferWorkshopStoreByKeysByPrint(this.branchId,
        consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.transferWorkshopStorePrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      this.transferWorkshopStorePrintModel = new TransferWorkshopStorePrintModel();
      console.error("Error al obtener impresión del traslado.", error);
    }
  }

  async getPrintInventoryEntryByFormat() {
    if (!this.validateBranchAndEnterprise()) return;
    const response = await firstValueFrom(this.inventoryEntryService.getPrintInventoryEntryByFormat(this.branchId));
    this.inventoryEntryModel = response;
    if (this.inventoryEntryModel.consecutive != '000') {
      this.formFormat.controls["consecutive"].patchValue(this.inventoryEntryModel.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } else {
      setTimeout(() => this.formFormat.controls["consecutive"].disable(), 100);
    }

    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async getPrintInternalOrderByFormat() {
    if (!this.validateBranchAndEnterprise()) return;
    this.internalOrderModel = await firstValueFrom(this.internalOrderService.getPrintInternalOrderByFormat(this.branchId));
    if (this.internalOrderModel.consecutive != '000') {
      this.formFormat.controls["consecutive"].patchValue(this.internalOrderModel.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
    } else {
      setTimeout(() => this.formFormat.controls["consecutive"].disable(), 100);
    }

    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async getMaintenanceOrderByKeysByPrintAsync(maintenanceOrderClass: number) {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      if (maintenanceOrderClass == ClassMaintenanceOrderEnum.programada) {
        const response = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderScheduledByKeysByPrintAsync(
          this.consecutive, this.branchId, false));
        this.maintenanceOrderScheduledPrintModel = response;
      } else {
        const response = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderByKeysByPrintAsync(
          this.consecutive, this.branchId, maintenanceOrderClass));

        if (maintenanceOrderClass == ClassMaintenanceOrderEnum.enSitio) {
          this.maintenanceOrderSitePrintModel = response;
        } else {
          this.maintenanceOrderWorkshopPrintModel = response;
        }
      }

      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener el consecutivo de la orden de mantenimiento:", error);
    }
  }

  async getMaintenanceRoutineByKeysByPrintAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.maintenanceRoutineService.getMaintenanceRoutinePrint(
        0, this.companyId, this.consecutive)
      );
      this.formFormat.controls["consecutive"].patchValue(response.articleCode);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.maintenanceRoutinePrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la rutina de mantenimiento:", error);
    }
  }

  async getNoteByKeysAsync() {
    try {
      if (!this.validateBranchAndEnterprise()) return;
      if (this.bussinessDocumentsTypeId != null && this.noteTypeId != null && this.consecutive != null) {
        const response = await firstValueFrom(
          this.noteService.getNoteByKeysAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeId, this.noteTypeId, this.consecutive, false)
        );
        this.getPrintNoteForFormat(response.noteId);
      } else {
        console.error('Error faltan datos clave para consultar la nota.');
      }
    } catch (error) {
      console.error('Error al obtener la nota:', error);
    }
  }

  async getPrintChargeAccountForFormat(invoiceId: number) {
    this.chargeAccountsPrintModel = await firstValueFrom(this.chargeAccountService.printsChargeAccounts(invoiceId, null, null, false));
  }

  async getPrintDocumentSupportForFormat(documentSupportId: number) {
    try {
      this.documentSupportPrintModel = await firstValueFrom(this.documentSupportService.printDocumentSupport(documentSupportId, false));
    } catch (error) {
      console.error('Error al buscar el formato de impresión de documentos soporte', error);
    }
  }

  async getPrintInternalOrder(internalOrderId: number) {
    try {
      this.internalOrderModel = await firstValueFrom(this.internalOrderService.getPrintInternalOrder(internalOrderId));
    } catch (error) {
      console.error('Error al buscar el formato de impresión de pedidos internos.', error);
    }
  }

  async getPrintInventoryEntryForFormat(inventoryEntryId: number) {
    try {
      this.inventoryEntryModel = await firstValueFrom(this.inventoryEntryService.getPrintInventoryEntry(inventoryEntryId));
    } catch (error) {
      console.error('Error al buscar el formato de impresión de entradas de inventario.', error);
    }
  }

  async getPrintInvoiceForFormat(invoiceId: number) {
    this.invoicesPrintModel = await firstValueFrom(this.invoiceService.printsInvoices(invoiceId, null, null, false));
  }

  async getPrintInvoicingCutoffForFormat(invoicingCutoffId: number) {
    const preinvoicingPrintModel = await firstValueFrom(this.movementService.getPrintPreinvoices(invoicingCutoffId, null, null, null));
    this.preinvoicingPrintModel = preinvoicingPrintModel.length > 3 ? preinvoicingPrintModel.slice(0, 3) : preinvoicingPrintModel;
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async getPrintPurchaseOrder(purchaseOrderId: number) {
    try {
      this.purchaseOrderPrintModel = await firstValueFrom(this.purchaseOrderService.printPurchaseOrder(purchaseOrderId));
    } catch (error) {
      console.error('Error al buscar el formato de impresión de ordenes de compras.', error);
    }
  }

  async getPrintNoteForFormat(noteId: number) {
    try {
      this.notePrintModel = await firstValueFrom(this.noteService.printNote(noteId, false));
      this.bussinessDocumentsTypeId = this.notePrintModel.bussinessDocumentsTypeId;
      this.noteTypeId = this.notePrintModel.noteTypeId;
    } catch (error) {
      console.error('Error al buscar el formato de impresión de notas:', error);
    }
  }

  async getSalesRemissionByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.salesRemissionService.getSalesRemissionByKeysForPrintAsync(0, this.inventoryId!, this.branchId, this.consecutive));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.salesRemissionPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la impresión de la remisión de venta por consecutivo.", error);
      this.salesRemissionPrintModel = new SalesRemissionPrintModel();
    }
  }

  async getPrintServiceForFormat(serviceId: number) {
    try {
      this.serviceModel = await firstValueFrom(this.serviceService.getServiceById(serviceId));
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al buscar el formato de impresión de servicios.', error);
    }
  }

  async getPrintSuspensionForFormat(suspensionId: number) {
    try {
      this.suspensionModel = await firstValueFrom(this.suspensionService.getSuspensionById(suspensionId));
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al buscar el formato de impresión de suspensiones.', error);
    }
  }

  async getPrintTransferConstructionSiteForFormat(transferConstructionSiteId: number) {
    try {
      this.transferConstructionSitePrintModel = await firstValueFrom(
        this.transferConstructionSiteService.printTransferConstructionSite(transferConstructionSiteId, false)
      );
    } catch (error) {
      console.error('Error al buscar el formato de impresión de traslado entre obras.', error);
    }
  }

  async getPurchaseOrderByKeys() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getPurchaseOrderByKeys(this.branchId, this.consecutive));
      this.getPrintPurchaseOrder(purchaseOrderModel.purchaseOrderId);
    } catch (error) {
      console.error('Error al buscar la orden de compra por llaves.', error);
    }
  }

  async getQuotationByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.quotationService.getQuotationByKeysByPrint(null, this.branchId, this.consecutive, true));
      if (response.consecutive !== 'COT-00001') {
        this.formFormat.controls["consecutive"].patchValue(response.consecutive);
        setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      }
      this.quotationPrintContract = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la remisión:", error);
      this.quotationPrintContract = new QuotationPrintModel();
    }
  }

  async getRemissionByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.remissionService.getRemissionByKeysByPrint(this.branchId, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.remissionPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la remisión:", error);
      this.remissionPrintModel = new RemissionPrintModel();
    }
  }

  async getServiceByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.serviceService.getServiceByKeysAsync(this.branchId, this.consecutive));
      this.getPrintServiceForFormat(response.serviceId);
    } catch (error) {
      console.error("Error al obtener el servicio por llaves:", error);
    }
  }

  async getSubrentalEntryByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.subrentalEntryService.getSubrentalEntryByKeysByPrint(this.branchId, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.subrentalEntryPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la entrada de subalquiler:", error);
      this.subrentalEntryPrintModel = new SubrentalEntryPrintModel();
    }
  }

  async getSubrentalOutputByKeysByPrint() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.subrentalOutputService.getSubrentalOutputByKeysByPrint(this.branchId, this.consecutive, 0));
      this.formFormat.controls["consecutive"].patchValue(response.consecutive);
      setTimeout(() => this.formFormat.controls["consecutive"].enable(), 100);
      this.subrentalOutputPrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error("Error al obtener la entrada de subalquiler:", error);
      this.subrentalOutputPrintModel = new SubrentalOutputPrintModel();
    }
  }

  async getInternalOrderByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.internalOrderService.getInternalOrderByKeysAsync(this.branchId, this.consecutive!));
      response.internalOrderId != 0 ? this.getPrintInternalOrder(response.internalOrderId) : this.getFormatEmpty();
    } catch (error) {
      console.error("Error al obtener el pedido interno por llaves:", error);
    }
  }

  async getTransferConstructionSiteByKeysAsync() {
    if (!this.validateBranchAndEnterprise()) return;
    try {
      const response = await firstValueFrom(this.transferConstructionSiteService.getTransferConstructionSiteByKeysAsync(this.branchId, this.consecutive));
      this.getPrintTransferConstructionSiteForFormat(response.transferConstructionSiteId);
    } catch (error) {
      console.error("Error al obtener el traslado de obra por llaves:", error);
    }
  }

  goToFormat() {
    if (this.formatModel().formatId && this.formatModel().formatId > 0) {
      this.router.navigate([`/format/register/${this.formatModel().formatId}`]);
    } else {
      this.toastHandlerService.showToast('warning', 'Seleccione un formato.');
    }
  }

  async handleInitialState() {
    if (this.formatId() !== null && this.formatId() !== 0 && this.formatId() !== undefined) {
      await this.getFormatById();
    } else {
      this.companyId = this.listCompany[0].value;
      this.formFormat.controls["companyId"].patchValue(this.companyId);
      this.formatModel().companyId = this.companyId;
    }
    await this.changeCompany(false);
    this.getFormatByCode(this.codeFormat);
  }

  async importFormat() {
    Object.keys(this.formFormat.controls).forEach(key => {
      const control = this.formFormat.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formFormat.valid) {
      if (this.companyId === CompanyEnums.altosSoftware) {
        this.branchId = 0;
        this.enterpriseId = 0;
        this.formFormat.patchValue({ branchId: 0, enterpriseId: 0 });
        this.hiddenView = false;
        this.getFormatEmpty();
        return;
      }

      this.consecutive = this.formFormat.get("consecutive")?.value;
      switch (this.formatModel().code) {
        case FormatsEnums.invoice: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.invoice)));
          await this.getFirstBussinessDocumentsType(BussinessDocumentsClassEnums.factura);
          if (this.consecutive === 0) {
            this.getLastInvoiceByKeysAsync();
          } else {
            this.getInvoiceByKeysAsync();
          }
          break;
        }
        case FormatsEnums.remission: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.remission)));
          await this.getRemissionByKeysByPrint();
          break;
        }
        case FormatsEnums.suspension: {
          await this.getSuspensionByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.devolution: {
          await this.getDevolutionByKeysByPrintAsync(false);
          break;
        }
        case FormatsEnums.predevolution: {
          await this.getDevolutionByKeysByPrintAsync(true);
          break;
        }
        case FormatsEnums.service: {
          await this.getServiceByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.inventoryEntry: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryEntry)));
          if (this.consecutive === 0) {
            this.getPrintInventoryEntryByFormat();
          } else {
            this.getInventoryEntryByKeysAsync();
          }
          break;
        }
        case FormatsEnums.inventoryOutput: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryOutput)));
          await this.getFirstInventoryByCompanyAuthenticatedAsync();
          await this.getInventoryOutputByKeysAsync(InventoryOutputTypeEnums.output);
          break;
        }
        case FormatsEnums.salesRemission: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.salesRemission)));
          await this.getFirstInventoryByCompanyAuthenticatedAsync();
          await this.getSalesRemissionByKeysAsync();
          break;
        }
        case FormatsEnums.inventoryTransfer: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryTransfer)));
          this.getInventoryTransferForPrint();
          break;
        }
        case FormatsEnums.subrentalEntry: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.subrentalEntry)));
          await this.getSubrentalEntryByKeysByPrint();
          break;
        }
        case FormatsEnums.subrentalOutput: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.subrentalOutput)));
          await this.getSubrentalOutputByKeysByPrint();
          break;
        }
        case FormatsEnums.preinvoicing: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.preinvoicing)));
          if (this.consecutive === 0) {
            this.getLastInvoicingCutoffByKeysAsync();
          } else {
            this.getInvoicingCutoffByKeysAsync();
          }
          break;
        }
        case FormatsEnums.liquidation: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.liquidation)));
          this.getLiquidationCutoffByKeysAsync();
          break;
        }
        case FormatsEnums.notes: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.notes)));
          if (this.consecutive === 0) {
            this.getLastNoteByKeysAsync();
          } else {
            this.getNoteByKeysAsync();
          }
          break;
        }
        case FormatsEnums.requestNote: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.requestNote)));
          this.getRequestNoteByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.chargeAccount: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.chargeAccount)));
          await this.getFirstBussinessDocumentsType(BussinessDocumentsClassEnums.cuentaCobro);
          if (this.consecutive === 0) {
            this.getLastChargeAccountByKeysAsync();
          } else {
            this.getChargeAccountByKeysAsync();
          }
          break;
        }
        case FormatsEnums.documentSupport: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.documentSupport)));
          await this.getFirstBussinessDocumentsType(BussinessDocumentsClassEnums.documSoporte);
          if (this.consecutive === 0) {
            this.getLastDocumentSupportByKeysAsync();
          } else {
            this.getDocumentSupportByKeysAsync();
          }
          break;
        }
        case FormatsEnums.cashReceipt: {
          this.getCashReceiptsByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.order: {
          await this.getOrderByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.transferConstructionSite: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.transferConstructionSite)));
          if (this.consecutive === 0) {
            this.getLastTransferConstructionSiteByKeysAsync();
          } else {
            this.getTransferConstructionSiteByKeysAsync();
          }
          break;
        }
        case FormatsEnums.transferStoreWorkshop: {
          await this.getTransferStoreWorkshopByKeysByPrint();
          break;
        }
        case FormatsEnums.transferWorkshopStore: {
          await this.getTransferWorkshopStoreByKeysByPrint();
          break;
        }
        case FormatsEnums.quotation: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.quotation)));
          await this.getQuotationByKeysByPrint();
          break;
        }
        case FormatsEnums.internalOrder: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.internalOrder)));
          if (this.consecutive === 0) {
            this.getPrintInternalOrderByFormat();
          } else {
            this.getInternalOrderByKeysAsync();
          }
          break;
        }
        case FormatsEnums.purchaseOrder: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.purchaseOrder)));
          this.consecutive = this.formFormat.get("consecutive")?.value;
          if (this.consecutive === 0) {
            this.getLastPurchaseOrderByKeys();
          } else {
            this.getPurchaseOrderByKeys();
          }
          break;
        }
        case FormatsEnums.maintenanceOrderSite: {
          if (this.consecutive === 0) {
            this.getLastMaintenanceOrderByKeysAsync(ClassMaintenanceOrderEnum.enSitio);
          } else {
            await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.enSitio);
          }
          break;
        }
        case FormatsEnums.maintenanceOrderWorkshop: {
          if (this.consecutive === 0) {
            this.getLastMaintenanceOrderByKeysAsync(ClassMaintenanceOrderEnum.enTaller);
          } else {
            await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.enTaller);
          }
          break;
        }
        case FormatsEnums.maintenanceOrderScheduled: {
          if (this.consecutive === 0) {
            this.getLastMaintenanceOrderByKeysAsync(ClassMaintenanceOrderEnum.programada);
          } else {
            await this.getMaintenanceOrderByKeysByPrintAsync(ClassMaintenanceOrderEnum.programada);
          }
          break;
        }

        case FormatsEnums.simpleEquipmentLogbook:
        case FormatsEnums.valuedEquipmentLogbook: {
          await this.getEquipmentLogbookByKeysByPrintAsync();
          break;
        }
        case FormatsEnums.costAdjustment: {
          await this.getCostAdjustmentByKeysByPrint();
          break;
        }
        case FormatsEnums.maintenanceRoutine: {
          this.formatModel.set(await firstValueFrom(this.formatServices.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.maintenanceRoutine)));
          await this.getMaintenanceRoutineByKeysByPrintAsync();
          break;
        }
      }
      this.hiddenView = false;
      this.formatDetailInput = new FormatDetailModel();
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'El campo Compañía es obligatorio.',
        min: 'Seleccione una Compañía válida.',
        notNumber: 'Debe seleccionar una Compañía válida.'
      },
      code: {
        required: 'El campo Formato es obligatorio.',
        min: 'Seleccione un Formato.',
        notNumber: 'Debe seleccionar un Formato válido.'
      },
      consecutive: {
        required: 'El campo Número es obligatorio.',
        min: 'El campo Número no puede ser negativo.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formFormat.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  onZoomChange($event: any): void {
    const zoomSlider = document.getElementById('zoomSlider');
    const zoomVal = document.getElementById('zoomVal');
    const spacer = document.getElementById('spacer');

    if (zoomSlider == null) return;

    let val = 0;
    val = Number($event.target.value ?? 0);
    document.documentElement.style.setProperty('--zoom', val.toString());
    if (zoomVal != null) {
      zoomVal.innerText = Math.round(val * 100).toString();
    }

    // AJUSTE CLAVE:
    // Para que el scroll funcione, el contenedor "spacer" debe crecer
    // manualmente porque transform: scale no empuja las paredes del div.
    const anchoBase = 21.59 * 37.8; // cm a px aprox
    if (spacer != null) {
      spacer.style.width = `${anchoBase * val + 300}px`;
    }
  };

  validateForm(format: FormatModel) {
    this.formFormat = this.formBuilder.group({
      companyId: [format.companyId, [Validators.required, CustomValidators.numberOnlyValidator(), Validators.min(1)]],
      code: [format.code, [Validators.required, CustomValidators.numberOnlyValidator(), Validators.min(1)]],
      consecutive: [this.consecutive, [Validators.required, Validators.min(0)]],
      branchId: [],
      enterpriseId: []
    });
  }

  validateBranchAndEnterprise(): boolean {
    if (this.branchId === 0 || this.branchId === null) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar una Sucursal.', 'Atención');
      return false;
    }

    if (this.enterpriseId === 0 || this.enterpriseId === null) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar una Empresa.', 'Atención');
      return false;
    }

    return true;
  }

  validateFormDetail(formatDetail: FormatDetailModel) {
    this.formFormatDetail = this.formBuilder.group({
      name: [formatDetail.name],
      visible: [formatDetail.visible],
      fontSize: [formatDetail.fontSize],
      bold: [formatDetail.bold],
      alignment: [formatDetail.alignment],
      border: [formatDetail.border],
      left: [formatDetail.left],
      top: [formatDetail.top],
      width: [formatDetail.width],
      height: [formatDetail.height],
      text: [formatDetail.text],
      formatType: [true],
      printFormat: [formatDetail.printFormat],
    });
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async userAuthenticatedIsPrincipalCompany() {
    try {
      const response = await firstValueFrom(this.userService.userAuthenticatedIsPrincipalCompany());
      this.isPrincipalCompany = response;
    } catch (error) {
      console.error('Error al validar si la compañía es principal.', error);
    }
  }

  async waitForComponenteImpresionToLoad(): Promise<void> {
    while (!this.finishLoadingPrint) {
      await this.sleep(100);
    }
  }

  private sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
